import { render, staticRenderFns } from "./itemLis.vue?vue&type=template&id=7dca4266&scoped=true&"
import script from "./itemLis.vue?vue&type=script&lang=js&"
export * from "./itemLis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dca4266",
  null
  
)

export default component.exports